import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <>
      <SEO
        title="404 - Siden blev ikke fundet - Akut Vikaren ApS"
        description="Beklager, den side du leder efter findes desværre ikke hos Akut Vikaren ApS."
      />

      <section className="min-h-[70vh] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8 bg-[#f8f7f4]">
        <div className="max-w-xl w-full text-center space-y-6 bg-white p-8 sm:p-12 rounded-2xl shadow-sm border border-[#eae6dd]">
          <div className="w-16 h-16 rounded-full bg-[#b39366]/20 text-[#b39366] flex items-center justify-center mx-auto text-2xl">
            <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
          </div>

          <div className="space-y-2">
            <span className="text-xs font-bold text-[#b39366] uppercase tracking-widest">Fejl 404</span>
            <h1 className="text-2xl sm:text-3xl font-extrabold text-[#041c2c] tracking-tight">
              Siden blev ikke fundet
            </h1>
            <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
              Det ser ud til, at siden du forsøgte at tilgå, er blevet flyttet eller ikke findes længere.
            </p>
          </div>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#b39366] hover:bg-[#a18155] text-white font-semibold px-5 py-2.5 rounded text-sm shadow transition-colors"
            >
              <i className="fa-solid fa-house text-xs" aria-hidden="true"></i>
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-800 font-semibold px-5 py-2.5 rounded text-sm transition-colors border border-slate-300"
            >
              <i className="fa-solid fa-envelope text-xs" aria-hidden="true"></i>
              <span>Kontakt os</span>
            </Link>
          </div>

          <div className="pt-6 border-t border-[#eae6dd] text-xs text-slate-500">
            <p>
              Har du brug for akut hjælp? Ring direkte til os på{' '}
              <a href="tel:+4523964042" className="text-[#b39366] font-bold hover:underline whitespace-nowrap">
                (+45) 23 96 40 42
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
